import type { Translations } from "../types";

const hu: Translations = {
  "meta.title": "Kattintások Országonként Térkép",
  "meta.description":
    "Interaktív világtérkép: ingyenes kattintások országonként, valamint fizetős támogatás Stripe, PayPal és Buy Me a Coffee segítségével.",

  "app.title": "Kattintások Országonként Térkép",

  "map.intro":
    "Kattints egy országra a térképen, hogy ingyenes szavazatot adj neki, vagy küldj neki anyagi támogatást - mindkettő beleszámít az alábbi kombinált ranglistába. A térkép csak az ezen az alkalmazáson belüli támogatást tükrözi, nem a tényleges nemzeti vagyont vagy GDP-t.",
  "map.verifying": "Ellenőrzés …",
  "map.confirmNotRobot": "Mielőtt ingyenes kattintásokat adhatnál hozzá, gyorsan erősítsd meg, hogy nem vagy robot:",
  "map.tryAgain": "Próbáld újra",
  "map.registeringClick": "Kattintás rögzítése …",
  "map.selectedCountry": "Kiválasztott ország: {name}.",
  "map.selectFirstFeedback": "Ország kiválasztva. Az ingyenes kattintás hozzáadásához először erősítsd meg alább, hogy nem vagy robot.",
  "map.verificationExpired": "Az ellenőrzés lejárt - erősítsd meg újra, hogy nem vagy robot.",
  "map.slowDown": "Egy kicsit lassabban - várj egy pillanatot a következő kattintás előtt.",
  "map.clickFailed": "Nem sikerült rögzíteni a kattintást. Kérjük, próbáld újra.",
  "map.clickErrorGeneric": "Hiba történt a kattintás rögzítésekor.",
  "map.leaderboardHeading": "Országok Ranglistája",
  "map.emptySelection": "Válassz egy országot a térképen, hogy kattints rá vagy támogasd.",
  "map.loadingData": "Adatok betöltése …",

  "worldmap.loadError": "Nem sikerült betölteni a térképet.",
  "worldmap.resetZoom": "Nagyítás visszaállítása",
  "worldmap.resetButton": "⤾ Visszaállítás",
  "worldmap.loadingMap": "Térkép betöltése …",
  "worldmap.unknownCountry": "Ismeretlen",
  "worldmap.ariaClicks": "{name}: {clicks} kattintás",
  "worldmap.tooltipClicks": "{clicks} kattintás",

  "legend.fewer": "Kevesebb kattintás",
  "legend.more": "Több kattintás",

  "list.empty": "Még nincs egyetlen kattintás sem. Legyél te az első!",
  "list.ariaLabel": "Országok ranglistája kattintások szerint",

  "human.siteKeyMissing": "A VITE_TURNSTILE_SITE_KEY nincs beállítva - a konfigurációhoz lásd a README-t.",
  "human.verificationFailedGeneric": "Az ellenőrzés sikertelen.",
  "human.networkError":
    "Az ellenőrzés nem érhető el (hálózati hiba) - ellenőrizd a VITE_SUPABASE_URL-t, hogy a verify-human telepítve van-e, és az ALLOWED_ORIGIN-t; lásd README/NAVODILA.",
  "human.verificationFailedRetry": "Az ellenőrzés sikertelen, próbáld újra.",

  "provider.stripe": "💳 Kártya (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Kiválasztott ország",
  "panel.currentlyRanked": "Jelenlegi helyezés: #{rank}",
  "panel.shareCopied": "Másolva ✓",
  "panel.shareShared": "Megosztva ✓",
  "panel.shareButton": "🔗 Megosztás",

  "panel.tableClicks": "Kattintások",
  "panel.tableFree": "Ingyenes",
  "panel.tablePaid": "Fizetős",
  "panel.rowAllTime": "Összesen",
  "panel.rowThisYear": "Idén",
  "panel.rowThisWeek": "Ezen a héten",
  "panel.rowToday": "Ma",

  "panel.totalCombined": "Összesen kombinálva:",
  "panel.totalSupport": "Összes támogatás:",

  "panel.paymentMethod": "Fizetési mód",
  "panel.noPaymentMethod": "Jelenleg nem áll rendelkezésre fizetési mód.",
  "panel.supportAmount": "Támogatás összege (EUR)",
  "panel.amountRange": "Az összegnek {min} és {max} között kell lennie.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Becsült fizetős kattintások:",
  "panel.ratioInfo":
    "Arány: {a} = {b} kattintás (pl. {c} = {d} kattintás). Ez csak egy becslés a fizetés előtt - a végleges kattintásszámot mindig a szerver számolja ki és erősíti meg a ténylegesen visszaigazolt fizetés alapján.",
  "panel.preparing": "Előkészítés …",
  "panel.continueWith": "Folytatás ezzel: {provider}",
  "panel.choosePaymentMethod": "Válassz fizetési módot",
  "panel.bmcUsernameMissing": "A VITE_BMC_USERNAME nincs beállítva - a konfigurációhoz lásd a README-t.",
  "panel.paypalClientIdMissing": "A VITE_PAYPAL_CLIENT_ID nincs beállítva - a konfigurációhoz lásd a README-t.",

  "panel.paypalAmountInfo": "Összeg: {amount} (becsülve {clicks} kattintás). Fejezd be a fizetést az alábbi PayPal gombbal.",
  "panel.back": "← Vissza",

  "panel.bmcWarningTitle": "⚠️ Mielőtt folytatnád a BuyMeCoffee-n:",
  "panel.bmcWarningBody":
    "Illeszd be az alábbi kódot a fizetésnél az üzenet/megjegyzés mezőbe — csak így fogjuk tudni, melyik országot támogatod. Kód nélkül nem tudjuk a fizetést egyetlen országhoz sem rendelni.",
  "panel.copy": "Másolás",
  "panel.copied": "Másolva ✓",
  "panel.suggestedAmount": "Javasolt összeg:",
  "panel.bmcAmountNote":
    "(becsülve {clicks} kattintás). A BuyMeCoffee sajnos nem támogatja az összeg linken keresztüli átadását — add meg/válaszd ki magad az oldalukon. A tényleges kattintásszámot mindig a BuyMeCoffee-n ténylegesen elküldött összeg alapján számoljuk, nem ebből a becslésből.",
  "panel.openBmc": "BuyMeCoffee megnyitása és folytatás →",
  "panel.waitingProvider": "Fizetési visszaigazolásra várunk a fizetési szolgáltatótól …",
  "panel.waitingConfirmation": "Fizetési visszaigazolásra várunk …",
  "panel.timedOut":
    "Az ellenőrzés túllépte az időkorlátot. Ha befejezted a fizetést, a térkép frissülni fog, amint a szerver megkapja a visszaigazolást - ez néha kicsit tovább is tarthat.",
  "panel.checkAgain": "Ellenőrzés újra",

  "panel.cancelled": "A fizetés megszakadt vagy nem sikerült. A térkép nem változott.",
  "panel.tryAgain": "Próbáld újra",

  "panel.confirmed": "✅ Támogatás megerősítve!",
  "panel.confirmedBody": "{country} {clicks} fizetős kattintást kapott {amount} összegért.",

  "panel.errorPreparingSupport": "Hiba történt a támogatásod előkészítésekor.",
  "panel.errorPreparingPayment": "Hiba történt a fizetés előkészítésekor.",
  "panel.errorConfirmingPayment": "Hiba történt a fizetés megerősítésekor.",
  "panel.errorPayingPaypal": "Hiba történt a PayPallal történő fizetéskor.",

  "share.unranked": "{flag}{country} szüksége van a támogatásodra a világtérképen!\nSegíts neki feljebb jutni a ranglistán 👇",
  "share.rank1": "{flag}{country} jelenleg az 1. helyen áll!\nSegíts, hogy a csúcson maradjunk 👇",
  "share.rankN": "{flag}{country} jelenleg a(z) #{rank}. helyen áll!\nSegíts, hogy az 1. helyre jussunk 👇",

  "language.switcherLabel": "Nyelv",
};

export default hu;
